/* Source text remains in native details, readable even without JavaScript. */
(() => {
  'use strict';
  const section = document.querySelector('#erfahrungen');
  const slider = section?.querySelector('[data-review-slider]');
  if (!slider || slider.hasAttribute('data-ready')) return;
  const track = slider.querySelector('[data-review-track]');
  const cards = Array.from(track.querySelectorAll('.kb-review-card'));
  const previous = slider.querySelector('[data-review-prev]');
  const next = slider.querySelector('[data-review-next]');
  const position = slider.querySelector('[data-review-position]');
  const dialog = section.querySelector('[data-review-dialog]');
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  slider.setAttribute('data-ready', '');
  const step = () => cards.length > 1 ? cards[1].getBoundingClientRect().left - cards[0].getBoundingClientRect().left : track.clientWidth;
  const perView = () => Math.max(1, Math.round(track.clientWidth / (step() || 1)));
  const firstIndex = () => Math.max(0, Math.round(track.scrollLeft / (step() || 1)));
  function updateState() {
    const first = firstIndex(), visible = perView();
    const from = Math.min(first + 1, cards.length), to = Math.min(first + visible, cards.length);
    position.textContent = visible > 1 ? `${from} bis ${to} von ${cards.length}` : `${from} von ${cards.length}`;
    previous.disabled = track.scrollLeft <= 4;
    next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
  }
  function page(direction) {
    track.scrollBy({left: direction * step() * perView(), behavior: reduceMotion.matches ? 'auto' : 'smooth'});
  }
  previous.addEventListener('click', () => page(-1));
  next.addEventListener('click', () => page(1));
  track.addEventListener('keydown', event => {
    if (event.target !== track) return;
    if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
      event.preventDefault(); page(event.key === 'ArrowRight' ? 1 : -1);
    }
    if (event.key === 'Home' || event.key === 'End') {
      event.preventDefault();
      track.scrollTo({left: event.key === 'Home' ? 0 : track.scrollWidth, behavior: reduceMotion.matches ? 'auto' : 'smooth'});
    }
  });
  let ticking = false;
  track.addEventListener('scroll', () => {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(() => { updateState(); ticking = false; });
  }, {passive: true});
  // Native horizontal swiping for touch/trackpads; dragging for mouse users.
  let drag = null;
  track.addEventListener('pointerdown', event => {
    if (event.pointerType !== 'mouse' || event.button !== 0 || event.target.closest('a,button,summary')) return;
    drag = {id: event.pointerId, x: event.clientX, left: track.scrollLeft, moved: false};
  });
  track.addEventListener('pointermove', event => {
    if (!drag || event.pointerId !== drag.id) return;
    const distance = event.clientX - drag.x;
    if (!drag.moved && Math.abs(distance) < 8) return;
    if (!drag.moved) {
      drag.moved = true; track.setPointerCapture(event.pointerId); track.classList.add('is-dragging');
    }
    event.preventDefault(); track.scrollLeft = drag.left - distance;
  });
  function endDrag(event) {
    if (!drag || (event && event.pointerId !== drag.id)) return;
    const moved = drag.moved;
    if (track.hasPointerCapture(drag.id)) track.releasePointerCapture(drag.id);
    drag = null; track.classList.remove('is-dragging');
    if (moved) track.scrollTo({left: firstIndex() * step(), behavior: reduceMotion.matches ? 'auto' : 'smooth'});
  }
  track.addEventListener('pointerup', endDrag);
  track.addEventListener('pointercancel', endDrag);
  track.addEventListener('lostpointercapture', () => { drag = null; track.classList.remove('is-dragging'); });
  track.addEventListener('pointerleave', event => { if (drag && !drag.moved) endDrag(event); });
  if (dialog && typeof dialog.showModal === 'function') {
    const dialogBody = dialog.querySelector('[data-review-dialog-body]');
    let returnFocus = null;
    function openReview(card, trigger) {
      if (!card) return;
      const content = card.querySelector('[data-review-content]').cloneNode(true);
      content.querySelector('h3').id = 'kb-review-dialog-title';
      dialogBody.replaceChildren(content); returnFocus = trigger;
      dialog.showModal(); dialog.scrollTop = 0;
    }
    cards.forEach(card => {
      const summary = card.querySelector('summary');
      summary.setAttribute('aria-haspopup', 'dialog');
      summary.addEventListener('click', event => { event.preventDefault(); openReview(card, summary); });
    });
    section.querySelectorAll('[data-review-open]').forEach(link => {
      link.setAttribute('aria-haspopup', 'dialog');
      link.addEventListener('click', event => {
        event.preventDefault(); openReview(document.getElementById(link.dataset.reviewOpen), link);
      });
    });
    dialog.addEventListener('click', event => {
      if (event.target !== dialog) return;
      const rect = dialog.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
    });
    dialog.addEventListener('close', () => returnFocus?.focus({preventScroll: true}));
  }
  updateState();
  window.addEventListener('resize', updateState, {passive: true});
  if ('ResizeObserver' in window) new ResizeObserver(updateState).observe(track);
  if (document.fonts?.ready) document.fonts.ready.then(updateState);
})();
